import React from 'react'
import { SVGProps } from 'react'

const CommercialIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2.6 1h10.8v1.8H2.6V1Z" />
    <path d="M1.2 6.4 2.4 3.6h11.2l1.2 2.8H1.2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 7.4h12V14a1 1 0 0 1-1 1H9.6v-4.2H6.4V15H3a1 1 0 0 1-1-1V7.4Zm9 1.4h1.6v2.4H11V8.8Z"
    />
  </svg>
)
export default CommercialIcon
